import { Box } from "@mui/material";
import { StructureSummary } from "common/interfaces/StructureSummary";
import React, { useCallback } from "react";
import styles from "../EstateFilterDialog.module.scss";

export const StructureSummaryButton = React.memo(
  (props: {
    structureSummariesMaster: StructureSummary[];
    structureSummaries: StructureSummary[];
    onStructureSummariesChange: (
      structureSummaries: StructureSummary[]
    ) => void;
  }) => {
    const onStructureSummaryClick = useCallback(
      (structureSummary: StructureSummary) =>
        props.onStructureSummariesChange(
          props.structureSummaries.some(
            (element) => element.id === structureSummary.id
          )
            ? props.structureSummaries.filter(
                (element) => element.id !== structureSummary.id
              )
            : [...props.structureSummaries, structureSummary]
        ),
      [props]
    );

    return (
      <>
        {props.structureSummariesMaster.map((structureSummary) => (
          <Box
            key={structureSummary.id}
            onClick={() => onStructureSummaryClick(structureSummary)}
            className={`${styles.btn_switch01} ${styles.click_act01} ${
              styles.pet
            } ${
              props.structureSummaries.includes(structureSummary)
                ? styles.on
                : styles.off
            }`}
          >
            {structureSummary.name}
          </Box>
        ))}
      </>
    );
  }
);
